module.exports = __webpack_public_path__ + "static/media/wave.859fdac7.png";